import { render } from "./CollectionHolders.vue?vue&type=template&id=5ecde74c"
import script from "./CollectionHolders.vue?vue&type=script&lang=js"
export * from "./CollectionHolders.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__